var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"can",rawName:"v-can",value:('FpPron11'),expression:"'FpPron11'"}],staticClass:"history",on:{"click":_vm.showMedicalRecordsModal}},[_c('IconHistory',{staticClass:"iconHistory"})],1),_c('MedicalRecordsModal',{attrs:{"patientId":_vm.attendanceId,"attendanceId":_vm.attendanceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }